// Colors defined here 🤾🏻‍♂️ https://www.figma.com/file/Lm0cTNbawUsMVJsryvepa3/Master-Reorganizing-WIP?node-id=3673%3A9434
export default [
  '#DD643E',
  '#E57560',
  '#BB644C',
  '#502529',
  '#694347',
  '#5F4241',
  '#845442',
  '#C99067',
  '#B9977A',
  '#DDAC8C',
  '#E8AF9D',
  '#F7CAAD',
  '#F7E1D8',
  '#CEA7C3',
  '#E7D0F7',
  '#FFF3D8',
  '#EAD39E',
  '#E1B269',
  '#C2862F',
  '#E0CD7B',
  '#5E6338',
  '#475233',
  '#EDEFF3',
  '#9FBFD6',
  '#B7D1F1',
  '#8EB6EA',
  '#4A6283',
  '#415371',
  '#355488',
  '#182941',
  '#727286',
  '#A39DAA',
  '#B4ADA5',
  '#DED8D4',
  '#121820',
  '#333333',
  '#666666',
  '#999999',
  '#FFFFFF',
];
